import { createAction } from '@reduxjs/toolkit'

import type {
  UserLoginRequestPayload,
  UserLoginSuccessPayload,
  UserLoginWithTokenRequestPayload
} from './types'

export const userLoginRequest =
  createAction<UserLoginRequestPayload>('USER_LOGIN_REQUEST')
export const userLoginWithTokenRequest =
  createAction<UserLoginWithTokenRequestPayload>(
    'USER_LOGIN_WITH_TOKEN_REQUEST'
  )
export const userLoginSuccess =
  createAction<UserLoginSuccessPayload>('USER_LOGIN_SUCCESS')
export const userLoginFailed = createAction('USER_LOGIN_FAILED')

export const userLogout = createAction('USER_LOGOUT_SUCCESS')
